import { forwardRef, type Ref, type SVGProps } from "react";
const IconChecklistEmptyFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <rect width={19} height={4} x={11} y={5} fill="currentColor" rx={2} />
    <rect width={19} height={4} x={11} y={14} fill="currentColor" rx={2} />
    <rect width={19} height={4} x={11} y={23} fill="currentColor" rx={2} />
    <rect width={6} height={6} x={2} y={4} fill="currentColor" rx={1.5} />
    <rect width={6} height={6} x={2} y={13} fill="currentColor" rx={1.5} />
    <rect width={6} height={6} x={2} y={22} fill="currentColor" rx={1.5} />
  </svg>
);
const ForwardRef = forwardRef(IconChecklistEmptyFilledSVG);
ForwardRef.displayName = "IconChecklistEmptyFilled";
export { ForwardRef as IconChecklistEmptyFilled };
